module.exports = "/images/sala_viajero_z01.jpg?6190fdbddacd5a4996d5342ac9296983";